import { saveMediaToOfflineStorage as saveImageToRepo } from '@/domains/deviceImages/repositories/deviceImageRepository';
import { syncService } from '@/services/sync/syncService';
import type {
  DeviceImageLinkages,
  DeviceImageRecord,
  ImageLocation,
} from '@/domains/deviceImages/types/deviceImagesType';

export const saveImageForSync = async (
  entityId: number,
  deviceImageTypeId: number,
  blob: Blob,
  location: ImageLocation | undefined,
  associations: DeviceImageLinkages = {}
): Promise<DeviceImageRecord> => {
  // Returns the Dexie record
  const metadata = {
    entityId,
    deviceImageTypeId,
    timestamp: Date.now(),
    latitude: location?.latitude,
    longitude: location?.longitude,
    routeId: associations.routeId ?? null,
    routeStopId: associations.routeStopId ?? null,
    shipmentGuid: associations.shipmentGuid ?? null,
    syncStatus: 'pending' as const,
    retryCount: 0,
  };

  try {
    // 1. Save to Cache Storage and Dexie (Repo)
    const savedImageRecord = await saveImageToRepo(blob, metadata);

    // 2. Enqueue in the SyncService
    const {
      id: imageId,
      cacheKey,
      entityId: savedEntityId,
      deviceImageTypeId: savedTypeId,
      routeId,
      routeStopId,
      shipmentGuid,
    } = savedImageRecord;
    try {
      await syncService.enqueue({
        type: 'IMAGE_CREATE',
        newRecord: {
          imageId,
          cacheKey,
          entityId: savedEntityId,
          deviceImageTypeId: savedTypeId,
          routeId,
          routeStopId,
          shipmentGuid,
        },
        oldRecord: null,
      });
    } catch (error) {
      console.warn('[deviceImagesService] Failed to enqueue image create sync job:', {
        imageId,
        entityId: savedEntityId,
        deviceImageTypeId: savedTypeId,
        cacheKey,
        error: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }

    return savedImageRecord; // Returns the Dexie record
  } catch (error) {
    console.error('Error in saveImageForSync service:', error);
    throw new Error('Failed to process image in offline mode.');
  }
};
